import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import arr from 'dojo/_base/array';
import color from 'dojo/_base/Color';
import topic from 'dojo/topic'; // löst connect ab!
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import RequestManager from 'more/RequestManager';
import PitHelper from './PitHelper';
import standby from 'dojox/widget/Standby';
import Evented from 'dojo/Evented';
import dateLocale from 'dojo/date/locale';
import _UiModder from '../moreCore/Tools/_UiModder';
import string from 'dojo/string';
import ParserWithBenefits from '../moreCore/Tools/_JsonParserWithBenefits';
import methodHooks from 'more/mdsMethodHooks';
// NOTE (JS2TS): ported from the 1750-LOC _WidgetBaseSP.js impl using the RequestManager pattern —
// the ambient `declare module 'more/_WidgetBaseSP'` (modules.d.ts) and the rich contract (types.d.ts:189)
// are KEPT UNCHANGED, so all 473 absolute `require("more/_WidgetBaseSP")` consumers keep their typed base.
// This module is the implementation only; consumers never resolve to it directly (baseUrl doesn't reach it),
// they resolve to the ambient decl. Dropped dead deps (dojo/keys, duplicate dojo/_base/Color alias).
// window-heavy → `w` alias; DOM-heavy → dom-construct aliased.
const w: any = window;
const domConstruct: any = domConstructTyped;

class _WidgetBaseSP extends methodHooks(compose(_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, Evented)) {
    [key: string]: any;

    _subscriptions: any = [];
    _userRoleCallbacks: any = null;
    _topics: any = [];
    _standbyOverlay: any = null;
    useStandbyManager = false;
    JSON: any = null;

    RequestManager: any = null;
    PitHelper: any = null;
    _standbyTargetNodeName = "domNode";
    _sidebarWidgetId = "mySidebar";
    appRoot: any = null;
    dojoDate: any = null;
    translations: any = [];
    globalContent: any = null;
    sidebar: any = null;
    UiModder: any = null;

    constructor(args?: any) {
        super(...(arguments as unknown as [])); // { 'value': 'blaaa' }
        lang.mixin(this, args);

        this.translations = w.translations;

        // Core widget state set in the CONSTRUCTOR (not postMixInProperties) so it
        // exists on EVERY _WidgetBaseSP subclass on `new` — wrapped by mdsWidget or
        // not. Programmatic / named-export widgets (e.g. EvService_ResourceLoadCheck)
        // are not mdsWidget-wrapped, so their create()/postMixInProperties never runs;
        // these are construction-safe (no DOM/registry dependency) and must not rely
        // on the render lifecycle. (dojo set much of this in the ctor too.)
        this._topics = [];
        this._subscriptions = [];
        this._tmpSubscriptions = [];
        this._userRoleCallbacks = [];
        this.dojoDate = dateLocale;
        this.RequestManager = new RequestManager();
        this.PitHelper = new PitHelper();
        this.UiModder = _UiModder;
        this.JSON = ParserWithBenefits;
        this.appRoot = w.appRoot;
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        // create()-time only: the sidebar widget must already be registered.
        this.sidebar = w.dijit.registry.byId(this._sidebarWidgetId);
        if (this.sidebar) {
            this.globalContent = this.sidebar.globalContentContainer;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.webPrivilegeManager = w.webPrivilegeManager;
        this.standbyManager = w.standbyManager;

        //Date.prototype.toJSON = function () {
        //    const hoursDiff = this.getHours() - this.getTimezoneOffset() / 60;
        //    this.setHours(hoursDiff);
        //    return this.toISOString();
        //}

        this._setupSubscriptions();
    }

    IsIEbrowser(): any {

        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || navigator.userAgent.indexOf("Trident/") > -1) {

            return true;
        }

        return false;
    }

    newDiv(innerHTML: any, styleStr?: any): any {
        return domConstruct.create("div", { innerHTML: innerHTML, style: styleStr });
    }



    dateToString(date: any, formatString?: any): any {
        if (!date) return "";
        if (!date.getDate) return "";

        let day = date.getDate();       // yields date
        let month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
        let year = date.getFullYear();  // yields year

        if (formatString) {
            return this.dojoDate.format(date, { datePattern: formatString, selector: "date" });
        }
        // After this construct a string with the above results as below
        return this.leadingZeros(day, 2) + "/" + this.leadingZeros(month, 2) + "/" + year;
    }
    dateToLocalISOString(date: any): any {
        return this.toLocalISOString(date);
    }
    toLocalISOString(date: any): any {
        if (!date) return "";
        if (typeof (date) != "object" || typeof (date.getDate) != "function") return "";

        var day = date.getDate();       // yields date
        var month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
        var year = date.getFullYear();  // yields year
        var hour = date.getHours();     // yields hours
        var minute = date.getMinutes(); // yields minutes
        var second = date.getSeconds(); // yields seconds

        // After this construct a string with the above results as below
        return year + "-" + this.leadingZeros(month, 2) + "-" + this.leadingZeros(day, 2) + "T" + this.leadingZeros(hour, 2) + ':' + this.leadingZeros(minute, 2) + ':' + this.leadingZeros(second, 2);
    }
    isTabExisting(tabname: any, containername?: any): any {
        return w.tabManager.isTabExisting(tabname, containername);
    }
    createNewTabbedContent(config: any, bActivate?: any, bReplaceExisting?: any): any {
        return this.requestNewTabbedContentGlobal(config, bActivate, bReplaceExisting);
    }
    requestNewTabbedContentGlobal(config: any, bActivate?: any, bReplaceExisting?: any): any {
        if (w.tabManager) {
            return w.tabManager.createNewTab(config, bActivate, bReplaceExisting);
        } else {
            topic.publish("/Tabbing/NewTabRequest", config);
            if (bActivate) {
                this.requestTabSwitchGlobal(config.name);
            }
        }
    }
    requestTabSwitchGlobal(tabname: any): void {
        topic.publish("/Tabbing/SwitchTabRequest", tabname);
    }
    activateTab(tabname: any, containername?: any): any {
        if (w.tabManager) {
            return w.tabManager.getExistingTab(tabname, containername, true) != null;
        } else {
            this.requestTabSwitchGlobal(tabname);
        }
    }
    getExistingTab(tabname: any, containername?: any): any {
        if (w.tabManager) {
            return w.tabManager.getExistingTab(tabname, containername);
        }
    }

    //requestEntityView(data) { // bitte EntityHelpers benutzen!
    //    topic.publish("/Entity/OpenView", data);
    //},

    getTabContainer(widget?: any, maxLevels?: any): any {
        if (!widget) widget = this;
        return this._getParentTabContainer(widget, maxLevels);
    }
    getTabContainerName(widget?: any, maxLevels?: any): any {
        if (!widget) widget = this;
        let tabContainer = this._getParentTabContainer(widget, maxLevels);
        if (tabContainer) return tabContainer["name"];
    }

    _getParentTabContainer(baseWidget: any, maxLevels?: any): any {
        if (w.tabManager) {
            return w.tabManager.getTabContainerOfWidget(baseWidget, maxLevels);
        }


        try {
            let parent = baseWidget.getParent()/* as dijit._Widget*/;

            if (!parent) return null;

            if (parent["declaredClass"] == "TabContainer" && parent["containerClasp"]) {
                return parent;
            } else {
                return this._getParentTabContainer(parent);
            }
        } catch (ex) {
            return null;
        }
    }



    dateTimeToString(date: any, formatStringDate?: any, formatStringTime?: any): any {

        if (!date) return "";
        if (!date.getDate) return "";

        if (formatStringDate || formatStringTime) {

            let options: any = {};

            if (formatStringDate) {
                options.datePattern = formatStringDate;
            }

            if (formatStringTime) {
                options.timePattern = formatStringTime;
            }

            if (!formatStringDate && formatStringTime) {
                options.selector = "time";
            } else if (formatStringDate && !formatStringTime) {
                options.selector = "date";
            }
            return this.dojoDate.format(date, options);
        }

        var day = date.getDate();       // yields date
        var month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
        var year = date.getFullYear();  // yields year
        var hour = date.getHours();     // yields hours
        var minute = date.getMinutes(); // yields minutes
        var second = date.getSeconds(); // yields seconds

        // After this construct a string with the above results as below
        return this.leadingZeros(day, 2) + "/" + this.leadingZeros(month, 2) + "/" + year + " " + this.leadingZeros(hour, 2) + ':' + this.leadingZeros(minute, 2) + ':' + this.leadingZeros(second, 2);
    }

    emitWithDomEvent(emitType: any, alternativeEmitterNode?: any, b?: any, c?: any): void {
        if (!alternativeEmitterNode) alternativeEmitterNode = this.domNode;

        if (alternativeEmitterNode) {
            let event = new Event(emitType);
            alternativeEmitterNode.dispatchEvent(event);
        }

        this.emit(emitType, b, c);
    }
    //emit: function (a, b, c) {
    //    this.inherited(arguments);
    //    // TOOD: Dom-Events auch ausführen?
    //},

    leadingZeros(num: any, size: any): any {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }

    // Funktioniert mit build-bat nicht (falls die Widgetbase mal wieder ins SP übernommen wird)
    stringFormat(template: any, ...args: any[]): any {
        return template.replace(/{(\d+)}/g, function (match: any, number: any) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    }
    hashCode(str: any): any {
        let hash = 0;
        for (let i = 0, len = str.length; i < len; i++) {
            let chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    stringReplaceAll(string: any, search: any, replacement: any): any {
        let target = string;
        try {
            return target.split(search).join(replacement);
        } catch (ex) {
            return string;
        }
    }

    getUrlAction(): any {
        var urlParams = location.pathname;
        //console.log("getUrlAction", urlParams);

        var action: any = false;

        if (urlParams != "" && urlParams != null && typeof (urlParams) != "undefined") {
            var pathParts = location.pathname.split("/");
            action = pathParts[pathParts.length - 1];
        }

        return action;
    }

    _replaceStateTimeout: any = null;
    _delayReplaceState(newurl: any): void {
        try {
            w.history.replaceState('', '', newurl);
        } catch (ex) {
            if (this._replaceStateTimeout) clearTimeout(this._replaceStateTimeout);
            this._replaceStateTimeout = setTimeout(lang.hitch(this, function (this: any, newurl: any) {
                try {
                    //console.debug(this.id + " replaceState", newurl);
                    w.history.replaceState('', '', newurl);
                } catch (ex) {

                }
            }, newurl), 300);
        }
    }
    removeUrlAction(actionName: any, bForce?: any): any { // JS2TS: 2nd arg preserved — caller passes `true` but the original body ignores it.
        var currentAction = this.getUrlAction();

        //console.debug("removeUrlAction", "currentAction: ", currentAction, "currentUrl: " + window.location.href);

        if (currentAction == false) {
            return false;
        }

        if (currentAction.toUpperCase() != actionName.toUpperCase() && actionName != "" && actionName != null && typeof (actionName) != "undefined") {
            return false;
        }

        //console.debug("removeUrlAction currentLocation", currentlocation, "newLocation: " + newLocation);

        var url = w.location.pathname;
        var newurl = url.replace(currentAction, "");
        //console.debug("removeUrlAction", "new url: " + newurl);
        this._delayReplaceState(newurl);

        return true;
    }

    setUrlAction(actionName: any, parameters?: any): any {
        var currentAction = this.getUrlAction();
        //console.debug("setUrlAction", "currentAction", currentAction, "current location: " + location.pathname);

        if (currentAction != false) {
            this.removeUrlAction(currentAction, true);
        }

        var currentlocation = location.pathname;
        var newLocation = currentlocation + "/" + actionName;
        newLocation = newLocation.replace("//", "/");

        //console.debug("setUrlAction after remove", "currentlocation: " + currentlocation, "newLocation: " + newLocation);

        var url = w.location.pathname; // gesamter Pfad
        var newurl = url + actionName;
        newurl = newurl.replace("//", "/");
        //console.debug("setUrlAction newurl", newurl);
        this._delayReplaceState(newurl);

        if (typeof (parameters) == "object") {
            for (var i = 0; i < parameters.length; i++) {
                var param = parameters[i];

                this.setUrlParameter(param.Name, param.Value);
            }
        }
    }

    getUrlParameterNames(): any {
        var urlParams = location.search;

        if (urlParams != "" && urlParams != null && typeof (urlParams) != "undefined") {
            var pathParts = location.pathname.split("/"); // /helpdesk/item/?id=0000000019 -> ["", helpdesk, item, ""]
            var action = pathParts[pathParts.length - 1]; // letzter Eintrag im Pfad, zb bei /helpdesk/item/?id=0000000019 wär das "",

            //console.debug("urlparams", urlParams, pathParts);

            var paramList: any = urlParams.slice(1);
            // id=xyz&type=abc

            paramList = paramList.split("&");
            // [id=xyz, type=abc]

            var paramNames = [];

            // zb  /helpdesk/item/?id=0000000019&comment=123123
            // paramlist = [id=0000000019, comment=123123]
            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split("=");

                paramNames.push(param[0]);
            }

            return paramNames;
        }

        return false;
    }

    getUrlParameterValue(paramName: any): any {

        if (typeof (paramName) == "undefined" || paramName == "" || paramName == null) {
            return false;
        }

        var urlParams = location.search;

        if (urlParams != "" && urlParams != null && typeof (urlParams) != "undefined") {
            var pathParts = location.pathname.split("/"); // /helpdesk/item/?id=0000000019 -> ["", helpdesk, item, ""]
            var action = pathParts[pathParts.length - 1]; // letzter Eintrag im Pfad, zb bei /helpdesk/item/?id=0000000019 wär das "",

            //console.debug("urlparams", urlParams, pathParts);

            // url im browser noch anpassen??
            //this.siteAction(action, urlParams);

            var paramList: any = urlParams.slice(1);
            // id=xyz&type=abc

            paramList = paramList.split("&");
            // [id=xyz, type=abc]

            //console.log("siteAction", action, paramString, paramList);


            // zb  /helpdesk/item/?id=0000000019&comment=123123
            // paramlist = [id=0000000019, comment=123123]
            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split("=");
                //console.log(param);
                if (param[0].toUpperCase() == paramName.toUpperCase()) {
                    var paramValue = param[1]; // ekus-ID!

                    return paramValue;
                    break;
                }
            }
        }

        return false;
    }

    removeUrlParameter(paramName: any): any {
        if (typeof (paramName) == "undefined" || paramName == "" || paramName == null) {
            return false;
        }

        var url = w.location.href; // gesamter Pfad
        var urlParams = w.location.search; // parameter: ?id=0000000019&comment=xyz

        if (urlParams != "" && urlParams != null && typeof (urlParams) != "undefined") {
            var pathParts = location.pathname.split("/"); // /helpdesk/item/?id=0000000019 -> ["", helpdesk, item, ""]

            var paramList: any = urlParams.slice(1); // "?" entfernen
            // id=xyz&type=abc

            paramList = paramList.split("&");
            // [id=xyz, type=abc]


            // zb  /helpdesk/item/?id=0000000019&comment=123123
            // paramlist = [id=0000000019, comment=123123]
            var newParamsstring = "";
            var iCount = 0;
            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split("=");
                //console.log(param);
                if (param[0].toUpperCase() != paramName.toUpperCase()) {
                    iCount++;
                    if (iCount == 1) {
                        newParamsstring += "?" + paramList[i];
                    } else {
                        newParamsstring += "&" + paramList[i];
                    }
                }
            }

            var newurl = url.replace(urlParams, newParamsstring);
            //console.log("new url:", newurl, "old:", url);
            this._delayReplaceState(newurl);
        }
    }

    setUrlParameter(paramName: any, paramValue: any): any {
        if (typeof (paramName) == "undefined" || paramName == "" || paramName == null) {
            return false;
        }

        if (typeof (paramValue) == "undefined" || paramValue == "" || paramValue == null) {
            this.removeUrlParameter(paramName);
            return;
        }

        var url = w.location.href; // gesamter Pfad
        var urlParams = w.location.search; // parameter: ?id=0000000019&comment=xyz

        if (urlParams == "" || urlParams == null || typeof (urlParams) == "undefined") {
            urlParams = "";
        }

        var newParamstring = paramName + "=" + paramValue;
        var oldValue = this.getUrlParameterValue(paramName);
        var newurl: any = "";

        //console.debug(this.id + " setUrlParameter");

        if (oldValue != false) {
            var oldParamstring = paramName + "=" + oldValue;
            // neuen Wert setzen

            var newurl = url.replace(oldParamstring, newParamstring);
            this._delayReplaceState(newurl);
        } else {

            var newParamsstring = urlParams;
            var paramList: any = urlParams.slice(1); // "?" entfernen
            // id=xyz&type=abc

            if (paramList.length > 0) {
                paramList = paramList.split("&");
            }

            //console.log("urlparams:", urlParams, "Paramlist split:", paramList, paramList.length)
            // [id=xyz, type=abc]

            if (paramList.length == 0) {
                newParamsstring = "?" + newParamstring;
                newurl = url + newParamsstring;
            } else {
                newParamsstring += "&" + newParamstring;
                newurl = url.replace(urlParams, newParamsstring);
            }

            this._delayReplaceState(newurl);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        //console.log("startup widgetbaseSP", this.id);
    }

    _tmpSubscriptions: any = [];

    addSubscription(topicName: any, callback: any): void {
        if (this._tmpSubscriptions === "done") { // bereits initialisiert, also nicht erst im Konstruktor
            this._topics.push({
                handle: topic.subscribe(topicName, callback),
                topic: topicName
            });

        } else {
            this._tmpSubscriptions.push({ "topic": topicName, "callback": callback });
        }
    }

    removeSubscription(topicName: any): any {
        return this.removeLiveCommandSubscription(topicName);
    }

    addLiveCommandSubscription(topic: any, callback: any): void {
        if (!topic) return;

        this.addSubscription("/LiveCommand/" + topic, callback);
    }

    removeLiveCommandSubscription(topic: any): any {
        for (let i = 0; i < this._topics.length; i++) {
            let subscription = this._topics[i];
            if (subscription.topic == topic) {
                subscription.handle.remove();

                this._topics.splice(i, 1);
                return true;
                break;
            }
        }

        return false;
    }

    protected _setupSubscriptions(): void {
        // subscribe( "namespace", <beliebige argumente> )
        this._topics.push({
            handle: topic.subscribe("/Session/CurrentSessionData", lang.hitch(this, this._trySessionDataCallbacks)),
            topic: "/Session/CurrentSessionData"
        });

        for (var i = 0; i < this._tmpSubscriptions.length; i++) {
            var subscription = this._tmpSubscriptions[i];
            this._topics.push({
                handle: topic.subscribe(subscription.topic, subscription.callback),
                topic: subscription.topic
            });
        }

        this._tmpSubscriptions = "done";
    }

    hourGlassStart(node?: any): void {
        if (!node) node = this.domNode;
        if (node.domNode) node = node.domNode;
        try {

            domClass.add(node, "egoAnimated_fadingHourglassOverlay")

            if (w.standbyManager && this.useStandbyManager === true) {
                w.standbyManager.addSpinner();
            }

        } catch (ex) {

        }
    }

    hourGlassEnd(node?: any): void {
        if (!node) node = this.domNode;
        if (node.domNode) node = node.domNode;
        try {
            domClass.add(node, "egoAnimated_fadingHourglassOverlay fadeout");
            setTimeout(lang.hitch(this, function (this: any) {
                try {
                    domClass.remove(node, "egoAnimated_fadingHourglassOverlay fadeout");

                    if (w.standbyManager && this.useStandbyManager === true) {
                        w.standbyManager.removeSpinner();
                    }
                } catch (ex) {
                    console.error(ex);
                }
            }), 1000);
        } catch (ex) {

        }
    }

    StandbyStartWithText(text: any, targetNode?: any, stepName?: any): void {
        let std = this.StandbyStart(targetNode, stepName);

        if (!std) std = this._standbyOverlay;

        if (text && std?.progressBarNode) {
            domConstruct.create("div", {
                "innerHTML": text,
                "className": "waitingText"
            }, std.progressBarNode);
        }
    }

    StandbyStart(targetNode?: any, stepName?: any, stepLabel?: any, stepCallback?: any, standbyName?: any): any {

        if (w.standbyManager && this.useStandbyManager === true) {
            if (this._destroyed != true) {
                //createStandby(groupname: string, target: HTMLElement | _WidgetBase, label?: string, initialSteps?: Array<string> | string)
                if (!targetNode) targetNode = this[this._standbyTargetNodeName];
                if (!standbyName) standbyName = this.id;
                let resultGroup = w.standbyManager.createStandby(standbyName, targetNode, null, stepName);

                if (stepName) {
                    if (stepLabel) {
                        //     addStep(steppath: string, callback?: Function, label?: string, groupname?: string) {
                        w.standbyManager.addStep(stepName, stepCallback, stepLabel, standbyName);
                    }
                }

                this.emit("StandbyStart");


                return resultGroup.standbywidget;
            }
        }

        try {
            if (!this._standbyOverlay) {
                this._standbyOverlay = new standby({
                    target: this[this._standbyTargetNodeName],
                    //color: "#ff0000",
                    /*image: require.toUrl("more/loadingbars-40px.svg").toString()*/
                });
                this._standbyOverlay.domNode.className = "dojoStandby starting";
                let pBar = this.UiModder.domConstruct.create("div",
                    { "className": "loadingBar ego_animated_progressBar" },
                    this._standbyOverlay.domNode.firstChild);
                pBar.style.setProperty("--durationModifier", (Math.random() - 1).toFixed(1) + "s");
                this._standbyOverlay["progressBarNode"] = pBar;

                document.body.appendChild(this._standbyOverlay.domNode);
            }


            if (this._standbyOverlay["progressBarNode"]?.firstChild) {
                domConstruct.destroy(this._standbyOverlay["progressBarNode"].firstChild);
            }


            if (this._destroyed !== true) {

                if (typeof (targetNode) != "undefined" && targetNode != null) {
                    this._standbyOverlay.target = targetNode;
                } else {
                    this._standbyOverlay.target = this[this._standbyTargetNodeName];
                }

                if (this._standbyAnimationHandle) clearTimeout(this._standbyAnimationHandle);

                domClass.add(this._standbyOverlay.domNode, "starting");
                domClass.remove(this._standbyOverlay.domNode, "stopping");

                this._standbyOverlay.show();

                setTimeout(lang.hitch(this, domClass.remove, this._standbyOverlay.domNode, "starting"), 10);

                this.emit("StandbyStart");

                return this._standbyOverlay;
            }
        } catch (ex) {
            console.warn("Standby-Start failed", ex);
        }
    }

    _standbyAnimationHandle: any = null;
    StandbyEnd(stepname?: any, standbyName?: any): void {

        this.emit("StandbyEnd");

        if (w.standbyManager && this.useStandbyManager === true) {
            if (!standbyName) standbyName = this.id;

            w.standbyManager.finishStep(stepname, standbyName);
        }

        if (this._standbyOverlay == null) {
            return;
        }

        if (this._destroyed !== true) {
            domClass.add(this._standbyOverlay.domNode, "stopping");

            this._standbyAnimationHandle = setTimeout(lang.hitch(this._standbyOverlay, "hide"), 350);
        }
    }

    StandbyStop(stepname?: any, standbyName?: any): void { // alias
        this.StandbyEnd(stepname, standbyName);
    }

    getTranslation(translationStr: any): any {
        return this.translate(translationStr);
    }
    canTranslate(translationStr: any, allowEmptyString?: any): any {
        if (translationStr == "") {
            return false;
        }
        if (this.translations) {
            let value = this.translations?.[translationStr];
            if (!!value) return true;
            else if (value == "" || value == null) {
                return allowEmptyString;
            } else if (typeof (value) == "undefined") {
                return false;
            }
        }

        return false;
    }
    translate(translationStr: any, allowEmptyString?: any): any {
        if (this.translations) {
            if (this.translations?.[translationStr]) {
                return this.translations[translationStr];
            } else if ((typeof (this.translations?.[translationStr]) as any) != undefined) { // JS2TS: original compares typeof (a string) to the value `undefined`, not "undefined" — always-true latent bug, preserved.
                if (allowEmptyString == true) return "";
            }
        }
        return "#" + translationStr;
    }

    setTitles(windowTitle: any, topBarTitle?: any): void {

        if (!windowTitle) {
            if (w.sidebar) {
                //windowTitle = window.sidebar.getSelectedSectionTitle();
            }
        } else {
            if (this.canTranslate(windowTitle)) {
                windowTitle = this.translate(windowTitle);
            }
        }

        if (!topBarTitle) {
            topBarTitle = windowTitle;
        } else {
            if (this.canTranslate(topBarTitle)) {
                topBarTitle = this.translate(topBarTitle);
            }
        }

        if (!windowTitle) {
            windowTitle = "";
            if (this.canTranslate("MainTitle")) {
                windowTitle = this.translate("MainTitle");
            }
            if (!topBarTitle) {
                topBarTitle = "";
            }
        } else {
            // es ist ein windowtitle übergeben worden. versuchen, den maintitle hineinzumappen:
            if (this.canTranslate("MainTitle")) {
                let newWindowTitle = this.stringFormat(windowTitle, this.translate("MainTitle", true));

                // schauen ob sich was geändert hat dadurch
                if (newWindowTitle == windowTitle) {
                    // Titel hat sich nicht geändert, es war also kein Platzhalter für den MainTitle drin
                    // jetzt kann es aber sein, dass jemand bei setTitles schon selber ein stringFormat gemacht hat
                    // also prüfen, ob der MainTitle nicht eh scon im windowTitle steht
                    if (newWindowTitle.indexOf(this.translate("MainTitle"), 0) == -1) {

                        // wenn nicht: den Fenstertitel selber hineinmappen
                        newWindowTitle = this.stringFormat(windowTitle + " - {0}", this.translate("MainTitle"));
                    }
                }

                windowTitle = newWindowTitle;
            } else {

            }
        }



        if (topBarTitle == null || topBarTitle == "") {
            topBarTitle = "";
        }

        let headingContainer = document.getElementById("mainMenuTitle");
        if (!headingContainer) headingContainer = document.getElementById("topBarTitle"); // neue Benennung ab 06-2024!
        if (headingContainer != null) {
            headingContainer.innerHTML = topBarTitle;
        }

        let productName = this.getCustomerSetting("productName");
        if (!!productName) {
            document.title = productName + " " + windowTitle;
            //console.log("setTitles", this.id, windowTitle, productName);
        } else if (windowTitle) {
            document.title = windowTitle;
        }


    }

    _cssClassname_Hidden = "w3-hide";

    // ständig domclass und w3-hide nervt!!
    hideNode(node: any, bTarget?: any, bSetInvisible?: any): void {
        if (!node) return;

        try {

            if (lang.isArray(node)) {
                for (let element of node) {
                    this.hideNode(element, bTarget, bSetInvisible);
                }

                return;
            }

            let actualNode = node;
            if (node.domNode) {
                actualNode = node.domNode;
            }

            if (bSetInvisible === true || bSetInvisible === false) {
                domClass.toggle(actualNode, "invisible", bSetInvisible);
            }

            if (bTarget !== false) {
                domAttr.set(actualNode, "hidden", true);
            } else {
                domAttr.remove(actualNode, "hidden");
            }

            if (bTarget === false) {
                domClass.remove(actualNode, this._cssClassname_Hidden + " hidden");
                return;
            }

            domClass.add(actualNode, this._cssClassname_Hidden);



        } catch (ex) {
            console.warn(this.id + ": hiding or unhiding node failed", node);
        }
    }

    isNodeHidden(node: any): any {
        let actualNode = node;
        if (node.domNode) {
            actualNode = node.domNode;
        }
        return domClass.contains(actualNode, "w3-hide");
    }

    disableNode(node: any, bTarget?: any): void {
        if (!node) return;

        if (lang.isArray(node)) {
            for (let element of node) {
                this.disableNode(element, bTarget);
            }

            return;
        }
        let disableAttribute = false;

        bTarget = bTarget !== false;

        if (node) {
            if ("disabled" in node) {
                disableAttribute = true;
            }
        }

        try {
            if (node.setReadonly) {
                node.setReadonly(bTarget);
            }
            domClass.toggle(node, "w3-disabled disabled", bTarget);

            if (disableAttribute) domAttr.set(node, "disabled", bTarget);

        } catch (ex) {
            console.warn(this.id + ": disabling or enabling node failed", node);
        }
    }

    cssRgbToRgb(cssRgb: any): any {
        try {
            //m = cssRgb.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
            var m = cssRgb.match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)$/i); // laut KI kanns damit auch RGBA

            if (m && m.length >= 4) {
                return [parseInt(m[1]), parseInt(m[2]), parseInt(m[3])];
            }
        } catch (ex) {
            console.warn(this.id + ": cannot parse rgb '" + cssRgb + "'");
        }

        return [];
    }

    rgbColorToHex(r: any, g: any, b: any): any {
        let hexR = r.toString(16);
        hexR = hexR.length == 1 ? "0" + hexR : hexR;

        let hexG = g.toString(16);
        hexG = hexG.length == 1 ? "0" + hexG : hexG;

        let hexB = b.toString(16);
        hexB = hexB.length == 1 ? "0" + hexB : hexB;

        return "#" + hexR + hexG + hexB;
    }

    getRgbFromString(colorStr: any): any {
        try {
            if (colorStr.length > 8) { // rgb( 10, 10, 10) - als css?
                let rgb = this.cssRgbToRgb(colorStr);
                if (rgb && rgb.length == 3) {
                    colorStr = this.rgbColorToHex(rgb[0], rgb[1], rgb[2]);
                }
            }
            if (colorStr.length >= 6) {
                let test = colorStr.substring(0, 1);
                if (test == "#") {
                    colorStr = colorStr.substring(1);      // strip #
                }

                colorStr = colorStr.substring(0, 6); // nur die ersten 6 Stellen

                let rgb = parseInt(colorStr, 16);   // convert rrggbb to decimal
                let r = (rgb >> 16) & 0xff;  // extract red
                let g = (rgb >> 8) & 0xff;  // extract green
                let b = (rgb >> 0) & 0xff;  // extract blue

                return [r, g, b];
            }
        } catch (ex) {
            console.warn(this.id + ": tried parsing rgb from invalid hexcolor '" + colorStr + "'");
        }
        return [];
    }

    getHexColorFromString(rgbOrCssClass: any): any {
        let result = null;
        let color: any = null;
        let css: any = null;
        if (this.isCssClassExisting(rgbOrCssClass)) {

            let testDiv = this.UiModder.domConstruct.create("div", {
                style: {
                    "position": "fixed",
                },
                "className": rgbOrCssClass
            }, document.body);

            css = w.getComputedStyle(testDiv);

            color = css.backgroundColor;

            this.UiModder.domConstruct.destroy(testDiv);
        } else if (rgbOrCssClass) {
            let rgb = this.getRgbFromString(rgbOrCssClass);
            if (rgb.length === 3) {
                return this.rgbColorToHex(rgb[0], rgb[1], rgb[2]);
            }

            let testDiv = this.UiModder.domConstruct.create("div", {
                style: {
                    "backgroundColor": rgbOrCssClass,
                }
            }, document.body);

            css = w.getComputedStyle(testDiv);

            color = css.backgroundColor;

            this.UiModder.domConstruct.destroy(testDiv);
        }


        if (color) {
            let rgb = this.getRgbFromString(color);
            if (rgb?.length == 3) {
                result = this.rgbColorToHex(rgb[0], rgb[1], rgb[2])
            }
        }

        return result;
    }

    isDarkColor(colorStr: any, threshold?: any): any {
        let rgb = this.getRgbFromString(colorStr);

        if (rgb && rgb.length == 3) {
            return this.isDarkRGBColor(rgb[0], rgb[1], rgb[2], threshold);
        }
    }
    isDarkRGBColor(r: any, g: any, b: any, threshold?: any): any {
        let result = false;

        if (typeof (threshold) != "number") threshold = 128;

        try {
            let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < threshold) {
                result = true;
            }
        }

        catch (ex) {
            console.warn("tried calculating brightness of invalid color-rgb: " + color);
            return null;
        }

        return result;
    }

    updateTopbarMargin(delay?: any): void {
        if (!delay || delay < 0) delay = 100;

        topic.publish("/Layout/UpdateTopbarMargin", delay);
    }

    createFontawesomeIcon(classnames: any, innerHTML?: any, parent?: any): any {
        if (!classnames) return null;

        let icon = domConstruct.create("i", { className: classnames, innerHTML: innerHTML ? innerHTML : "" });
        if (parent) {
            domConstruct.place(icon, parent);
        }

        return icon;
    }

    _getAllCssSelectors(): any {
        var result = [];
        for (var i = 0; i < document.styleSheets.length; i++) {
            try {

                var rules: any = document.styleSheets[i].cssRules;
                for (var x in rules) {

                    if (typeof rules[x].selectorText == 'string') result.push(rules[x].selectorText);
                }
            } catch (ex) {

            }
        }

        return result;
    }


    isCssClassExisting(selector: any): any {
        let selectors = this._getAllCssSelectors();
        if (selector && selector.substr(0, 1) != ".") {
            selector = "." + selector;
        }
        return selectors.indexOf(selector) != -1;

    }

    /**
     * override from dijit._TemplatedMixin to ignore JS-Errors if translations are missing
     * @param {any} tmpl
     */
    _stringRepl(tmpl: any): any {
        // summary:
        //		Does substitution of ${foo} type properties in template string
        // tags:
        //		private
        var className = this.declaredClass, _this = this;
        // Cache contains a string because we need to do property replacement
        // do the property replacement
        return string.substitute(tmpl, this, function (this: any, value: any, key: any) {
            if (key.charAt(0) == '!') { value = lang.getObject(key.substr(1), false, _this); }
            if (typeof value == "undefined") { return "#" + key; } // a debugging aide
            if (value == null) { return ""; }

            // Substitution keys beginning with ! will skip the transform step,
            // in case a user wishes to insert unescaped markup, e.g. ${!foo}
            return key.charAt(0) == "!" ? value : this._escapeValue("" + value);
        }, this);
    }

    getCurrentEmployeeId(callback?: any, bActualEmployeeId?: any): any {
        let tryCallback = true;

        if (w.sessionInfo) {
            if (w.sessionInfo.isSessionOpen()) {
                tryCallback = false;
                let value = w.sessionInfo.getCurrentEmployeeId(bActualEmployeeId === true);
                if (typeof (callback) == "function") {

                    callback(value);
                }
                this._employeeIdCallback = null;
                return value;
            }
        }
        if (tryCallback == true && typeof (callback) == "function") {
            this._employeeIdCallback = lang.hitch(this, this.getCurrentEmployeeId, callback, bActualEmployeeId);
        }
        return null;
    }

    getCurrentUserId(callback?: any, bActualUserId?: any): any {
        let tryCallback = true;

        if (w.sessionInfo) {
            if (w.sessionInfo.isSessionOpen()) {
                tryCallback = false;
                let value = w.sessionInfo.getCurrentWebuserId(bActualUserId === true);
                if (typeof (callback) == "function") {

                    callback(value);
                }
                this._userIdCallback = null;
                return value;
            }
        }
        if (tryCallback == true && typeof (callback) == "function") {
            this._userIdCallback = lang.hitch(this, this.getCurrentUserId, callback, bActualUserId);
        }
        return null;
    }

    getCurrentUserName(callback?: any, getActualUsername?: any): any {
        let tryCallback = true;

        if (w.sessionInfo) {
            if (w.sessionInfo.isSessionOpen()) {
                tryCallback = false;
                let value = w.sessionInfo.getUserName(getActualUsername === true);
                if (typeof (callback) == "function") {

                    callback(value);
                }
                this._userNameCallback = null;
                return value;
            }
        }
        if (tryCallback == true && typeof (callback) == "function") {
            this._userNameCallback = lang.hitch(this, this.getCurrentUserName, callback, getActualUsername);
        }
        return null;
    }

    _userDisplayNameCallback: any = null;
    _userNameCallback: any = null;
    _userIdCallback: any = null;
    _employeeIdCallback: any = null;

    getCurrentUserDisplayName(callback?: any, getActualUserDisplayname?: any): any {
        let tryCallback = true;

        if (w.sessionInfo) {
            if (w.sessionInfo.isSessionOpen()) {
                tryCallback = false;
                let value = w.sessionInfo.getUserDisplayName(getActualUserDisplayname === true);
                if (typeof (callback) == "function") {

                    callback(value);
                }
                this._userDisplayNameCallback = callback;
                return value;
            }
        }

        if (tryCallback == true && typeof (callback) == "function") {
            this._userDisplayNameCallback = lang.hitch(this, this.getCurrentUserDisplayName, callback, getActualUserDisplayname);
        }

        return null;
    }


    //getFeature: function (modulename) {
    //    return this.getModule(modulename);
    //},
    getModule<T = any>(modulename: any): T {

        if (!!modulename) {
            modulename = modulename.toLowerCase();
        } else return false as any;
        let result: any = false;

        if (w.customerSettings?.modules) {
            for (let entry of w.customerSettings.modules) {
                let name = entry.name;
                name = name.toLowerCase();
                if (name == modulename) {
                    if (!result) {
                        result = {};
                    } else {
                        console.warn("Module '" + modulename + "' is duplicate in config. Check customersettings in Appsettings!");
                    }

                    for (let key in entry) {

                        if (result.hasOwnProperty(key)) {
                            // gibts das Property schon?
                            let keyValue = entry[key];
                            if (lang.isArray(keyValue)) {
                                for (let val of keyValue) {
                                    result[key].push(lang.clone(val));
                                }
                            } else {
                                result[key] = lang.clone(entry[key]);
                            }

                        } else {
                            result[key] = lang.clone(entry[key]);
                        }
                    }
                }
            }
        }

        return result;
    }
    hasModuleVersion(moduleName: any, minVersion?: any, maxVersion?: any): any {
        let module = this.getModule(moduleName);

        // wenn jemand doch noch versehentlich yyMMddHHmm angegeben hatt, statt yyMMdd.HHmm
        if (minVersion > 999999) {
            minVersion = minVersion / 10000; // 4 Stellen nach rechts rücken
        }
        if (maxVersion > 999999) {
            maxVersion = maxVersion / 10000; // 4 Stellen nach rechts rücken
        }

        if (module != null) {
            if (minVersion > 0 || maxVersion > 0) {
                if (module.version > 0) {
                    if (module.version > 999999) {
                        // falsches Format yyMMddHHmm => muss yyMMdd.HHmm sein!
                        module.version = module.version / 10000;
                    }
                    if (minVersion > module.version) module = null;
                    else if (maxVersion < module.version) module = null;
                }

                else module = null;
            }
        }


        return !!module;
    }
    // WIRD ABGELÖST!! hasModule nicht mehr verwenden!!
    hasModule(modulename: any, featurename?: any): any {

        return this.hasFeature(modulename, featurename);
    }

    hasFeature(modulenameOrFeaturePath: any, featurename?: any, minVersion?: any, maxVersion?: any): any {

        let moduleName = modulenameOrFeaturePath;
        let parts = modulenameOrFeaturePath?.split("/");
        if (parts && parts.length && parts.length == 1) {
            parts = modulenameOrFeaturePath?.split(".");
        }

        if (parts && parts.length >= 2) {
            moduleName = parts[0];
            featurename = parts[1];
            if (parts.length >= 3 && !minVersion) {
                try {
                    minVersion = parseFloat(parts[2]);
                    // wenn jemand doch noch versehentlich yyMMddHHmm angegeben hatt, statt yyMMdd.HHmm
                    if (minVersion > 999999) {
                        minVersion = minVersion / 10000; // 4 Stellen nach rechts rücken
                    }

                } catch (ex) {
                    console.warn("featurepath error: cannot parse minversion of path " + modulenameOrFeaturePath, ex);
                }
            }
        }

        if (!moduleName) return false;

        let module = this.getModule(moduleName);

        if (minVersion > 0 || maxVersion > 0) {
            if (!this.hasModuleVersion(moduleName, minVersion, maxVersion)) {
                module = false;
            }
        }

        if (!module) return false;

        if (featurename) {
            featurename = featurename.toLowerCase();
        }


        if (featurename) {
            for (let entryFeature of module.features) {
                if (entryFeature) entryFeature = entryFeature.toLowerCase();
                if (entryFeature == featurename) {
                    return true;
                }
            }

            return false;
        } else {
            return true;
        }

        return false;
    }

    getCustomerSetting<T = any>(settingName: any): T {
        if (typeof (w.customerSettings) != "undefined") {
            if (w.customerSettings[settingName]) {
                return w.customerSettings[settingName];
            }
        }

        return null;
    }

    async hasUserRoleAsync(role: any, entity?: any, ClassnameProperty?: any, IdProperty?: any): Promise<any> {
        return new Promise((resolve: any) => {
            this.hasUserRole(role, (res: any) => {
                resolve(res);
            }, entity, ClassnameProperty, IdProperty);
        });
    }

    hasUserRole(role: any, callback?: any, entity?: any, ClassnameProperty?: any, IdProperty?: any): any {
        //console.debug("hasUserRole?", role, window.sessionInfo);
        var tryCallback = true;

        if (w.sessionInfo?.sessionData?.Roles) {

            tryCallback = false;
            let storageDebugsetting = false;
            try {
                let data = JSON.parse(localStorage.getItem("ego_DebugUserroles"));
                storageDebugsetting = data.state === true && data.userName == w.sessionInfo.getUserName();
            } catch (ex) {

            }

            if (entity && this.hasFeature("System/dynamicUserRoles")) {

                let classname = entity.Classname;
                let entityID = entity.ID;

                if (ClassnameProperty && typeof (ClassnameProperty) == "string" && (Object.keys(entity) as any).contains(ClassnameProperty)) classname = entity[ClassnameProperty];
                if (IdProperty && typeof (IdProperty) == "string" && (Object.keys(entity) as any).contains(IdProperty)) entityID = entity[IdProperty];

                if (w.webPrivilegeManager) {
                    if (w.webPrivilegeManager.isLoaded(entityID, role)) {
                        let result = w.webPrivilegeManager.checkEntityPrivilege(role, classname, entityID);
                        if (callback) callback(result, role);
                        return result;
                    }
                }

                if (!callback) return false; // ohne Callback können wir nicht asynchron anfragen obs fürs Entity passt

                if (w.webPrivilegeManager) {
                    w.webPrivilegeManager.checkEntityPrivilege(role, classname, entityID, callback);
                    return false;
                }

                this.RequestManager.post(
                    w.appRoot + "Entity/CheckEntityWebPrivilege",
                    {
                        role: role,
                        entityClass: classname,
                        entityID: entityID
                    },
                    lang.hitch(this, this._onCheckDynamicWebPrivilegeResult, callback),
                    lang.hitch(this, this._onCheckDynamicWebPrivilegeError, callback)
                );

                return false;
            }


            if (role.length && typeof (role) == "object") {
                // Array!
                let result = true;
                for (let singleRole of role) {
                    result = result && this.hasUserRole(singleRole);
                }



                if (callback) {
                    callback(result, role);
                }

                return result;
            }


            if (w.sessionInfo.sessionData.Roles.indexOf(role) != -1) {


                if (storageDebugsetting) {
                    console.info("checking for role: ", role, true, this.id);
                }

                if (typeof (callback) == "function") {
                    callback(true, role);
                }

                return true;
            } else {
                if (storageDebugsetting) {
                    console.warn("checking for role: ", role, false, this.id);
                }

                if (typeof (callback) == "function") {
                    callback(false, role);
                }
                return false;
            }
        }

        if (tryCallback == true && typeof (callback) == "function") {
            this._userRoleCallbacks.push({
                role: role,
                callback: callback,
                entity: entity,
                ClassnameProperty: ClassnameProperty,
                IdProperty: IdProperty
            });
        }

        if (this.hasModule("System\LogMissingRoles")) {
            console.info("Missing webuser role: '" + role + "' @ " + this.id);
        }
        return false;
    }

    _trySessionDataCallbacks(): void {
        //console.debug("_trySessionDataCallbacks: " + this.id, this._userRoleCallbacks);
        if (this._userRoleCallbacks.length > 0) {

            this._tryUserRoleCallback();
        }

        if (this._userDisplayNameCallback) {
            let result = this.getCurrentUserDisplayName();
            this._userDisplayNameCallback(result);
            this._userDisplayNameCallback = null;
        }


        if (this._employeeIdCallback) {
            this._employeeIdCallback();
            this._employeeIdCallback = null;
        }

        if (this._userIdCallback) {
            this._userIdCallback();
        }

        if (this._userNameCallback) {
            this._userNameCallback();
        }
    }

    _tryUserRoleCallback(): void {
        let storedCallbacks = [...this._userRoleCallbacks];
        this._userRoleCallbacks = [];

        for (let userRoleCallback of storedCallbacks) {
            let requestedRole = userRoleCallback.role;
            let targetEntity = userRoleCallback.entity;
            let classnameProperty = userRoleCallback.ClassnameProperty;
            let idProperty = userRoleCallback.IdProperty;
            let callback = userRoleCallback.callback;

            if (targetEntity) {
                this.hasUserRole(requestedRole, callback, targetEntity, classnameProperty, idProperty);
            } else {
                let result = this.hasUserRole(requestedRole);
                callback(result, requestedRole);
            }
        }


    }

    _onCheckDynamicWebPrivilegeResult(callback: any, result: any): void {
        callback(result);
    }
    _onCheckDynamicWebPrivilegeError(callback: any, error: any): void {
        console.error("privilege check failed!", error.Message);
        this._onCheckDynamicWebPrivilegeResult(callback, false);
    }

    //consoleLog: function (args) {
    //    if (this.hasUserRole("_DEBUG")) {
    //        console.log(args);
    //    }
    //},

    //consoleDebug: function (args) {
    //    if (this.hasUserRole("_DEBUG")) {
    //        console.debug(args);
    //    }
    //},

    //consoleWarn: function (args) {
    //    if (true) {//this.hasUserRole("_DEBUG")) {
    //        console.warn(args);
    //    }
    //},

    //consoleError: function (args) {
    //    if (true) {//this.hasUserRole("_DEBUG")) {
    //        console.log(args);
    //    }
    //},

    //consoleInfo: function (args) {
    //    if (this.hasUserRole("_DEBUG")) {
    //        console.log(args);
    //    }
    //},

    showToast(configOrText: any, iconClass?: any, ID?: any): any {

        if (!configOrText) return null;

        if (typeof (configOrText) == "string") {
            let title = configOrText;
            configOrText = {
                title: title,
                iconClass: iconClass
            };
        }
        if (iconClass) configOrText.iconClass = iconClass;

        if (!configOrText.options) {
            configOrText.options = {

            };
        }

        if (ID) {
            configOrText.options.ID = ID;
        } else if (configOrText.ID) {
            configOrText.options.ID = configOrText.ID;
        }

        if (!configOrText.options.ID) {
            configOrText.options.ID = "TM-" + (Math.random() * 100000).toString();
        }

        topic.publish("/Toaster/ShowToast", configOrText);


        return configOrText.options.ID;

    }

    removeToast(ID: any): void {
        topic.publish("/Toaster/RemoveToast", ID);
    }

    colorNode(node: any, entityColor: any, fallbackBGhex?: any, fallbackTXThex?: any): void {
        /*
        BackColor: {
        Hex: string;
        IsNull: boolean;
        Red: Number;
        Green: Number;
        Blue: Number;
    };
    TextColor: {
        Hex: string;
        IsNull: boolean;
        Red: Number;
        Green: Number;
        Blue: Number;
    };
        */
        if (!node) return;

        if (lang.isArray(node)) {
            for (let element of node) {
                this.colorNode(element, entityColor, fallbackBGhex, fallbackTXThex);
            }

            return;
        }

        let bgValue = null;
        let txtValue = null;

        if (entityColor) {
            if (entityColor.BackColor) {
                if (entityColor.BackColor.Hex) {
                    bgValue = entityColor.BackColor.Hex;
                }
            }

            if (entityColor.TextColor) {
                if (entityColor.TextColor.Hex) {
                    txtValue = entityColor.TextColor.Hex;
                }
            }
        }

        if (!bgValue && !!fallbackBGhex) {
            bgValue = fallbackBGhex;
        }
        if (!!bgValue && !txtValue && !fallbackTXThex) {
            txtValue = "var(--dark)";
            if (this.isDarkColor(bgValue)) {
                txtValue = "var(--bright)";
            }
        }
        if (!txtValue && !!fallbackTXThex) {
            txtValue = fallbackTXThex;
        }

        domStyle.set(node, "color", txtValue);
        domStyle.set(node, "backgroundColor", bgValue);
    }

    _destroySubscribers(): void {
        arr.forEach(this._subscriptions, function (subscription: any) {
            //connect.unsubscribe(subscription);
            if (typeof (subscription.remove) == "function") {
                subscription.remove();
            }
        });

        arr.forEach(this._topics, function (subscription: any) {
            //connect.unsubscribe(subscription);
            if (typeof (subscription.handle.remove) == "function") {
                subscription.handle.remove();
            }
        });
    }

    refreshGlobalContent(): void {
        if (this.globalContent) {
            domConstruct.empty(this.globalContent);
        }
    }

    destroy(): void {
        this._destroySubscribers();
        this.RequestManager.destroy();

        if (this._standbyOverlay) {
            //this._standbyOverlay.uninitialize();
            document.body.removeChild(this._standbyOverlay.domNode);
            this._standbyOverlay.destroy();
        }
        super.destroy.apply(this, arguments as any);
    }
}
_WidgetBaseSP.prototype.declaredClass = 'more._WidgetBaseSP';

export default mdsWidget(_WidgetBaseSP);
